import {
  SendToAgenciesSummaryViewQuery,
  SendToAgenciesSummaryViewQueryVariables,
  PriceRange,
} from 'types/graphql';
import { QUERY_sendToAgenciesSummaryView } from 'queries';
import { UseGQLQueryConfig } from 'hooks/useGQLQuery/useGQLQuery.types';
import { createApolloClient } from 'providers/ApolloProvider';
import { InMemoryCache } from '@apollo/client';
import { FetchJaneByIdData } from 'modals/ShiftModal/src/views/SendToAgenciesView/SendToAgenciesSummaryView/DirectRequests/FetchJaneByJaneId.data.context';

export const priceFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

export function parsePrice(price?: string) {
  if (!price) throw new Error('Data Error: Price cannot be undefined');
  return Number.parseFloat(price ? price.replace('$', '') : '0.0');
}

export function buildTotalEstimatedPayoutRange(priceRange: PriceRange, duration: number) {
  if (!priceRange || (!priceRange.max && !priceRange.min)) return '$00.00';
  const { min, max } = priceRange;
  return min === max
    ? priceFormatter.format(parsePrice(min) * duration)
    : `${priceFormatter.format(parsePrice(min) * duration)} - ${priceFormatter.format(
        parsePrice(max) * duration,
      )}`;
}

const apolloClient = createApolloClient({
  cache: new InMemoryCache(),
});

export const fetchJaneByIdQueryConfig = (
  janeId: string,
  marketPlaceJaneId: string,
  positionId?: number,
  locationId?: number,
): UseGQLQueryConfig<
  SendToAgenciesSummaryViewQuery,
  Nullable<FetchJaneByIdData>,
  SendToAgenciesSummaryViewQueryVariables
> => ({
  key: 'SEND_TO_AGENCIES_SUMMARY_VIEW_FETCH_JANE_QUERY',
  query: QUERY_sendToAgenciesSummaryView,
  client: apolloClient,
  variables: {
    jane_id: janeId || marketPlaceJaneId,
    withSupplyMappedPosition: positionId,
    locationId: Number(locationId),
  },
  responseTransformer(data: SendToAgenciesSummaryViewQuery): Nullable<FetchJaneByIdData> {
    if (!data?.fetchJane) return null;
    const position = data.fetchJane?.positions?.[0];
    const janeRateRaw =
      position?.agencyDetails?.openRate ||
      position?.communityDetails?.chargeRate?.toString() ||
      data.fetchJane?.primaryPosition?.details?.chargeRate?.toString() ||
      '';
    return {
      ...data,
      janeEstimatedPayout: janeRateRaw,
    };
  },
});
